import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import {
  Box,
  Grid,
  IconButton,
  MenuItem,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from '@react-google-maps/api';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { GetAllStates } from '../../../screen/auth/action/util_actions';
import { formatCompleteAddress } from '../../../utils/settings';
import Entity from '../../../v3/Common/Entity';
import { getAddressTagsAction } from '../../../v3/MyAccount/Address/APIs/action';
import { MODULE_PERMISSION_ENUM } from '../../../v3/Sidebar/Enum';
import { StandardChip, TextField } from '../../MUI_custom_component';
import CustomButton from '../../MUI_custom_component/Button/CustomButton';
import ReusableModal from '../../MUI_custom_component/Modal/CustomModal';
import CustomSelect from '../../MUI_custom_component/Select/CustomSelect';
import {
  GetAllCityOfState,
  getLocationAndPincodeAction,
} from '../../Onboarding/auth/action';
import {
  convertAddressToCoordinates,
  reverseGeocodeAction,
} from '../APIs/action';
import { mapStyles } from '../mapStyles';
import AddressConfirmationModal from './AddressConfirmationModal';

const AddressFormModal = ({
  onBack,
  onSaveAddress,
  addressDetails = {},
  selectedSapCode = '',
  selectedCompanyEsiId = null,
  coords = { lat: null, lng: null },
  isAddressBeingEdited = false,
  non_reward = false,
  onAddressAdded = () => {}, // Default empty function
}) => {
  const { is_PWA } = useSelector((state) => ({
    is_PWA: state.loginReducer.is_PWA,
  }));
  const { selectedCompany } = useSelector((state) => ({
    selectedCompany: state.AddressReducer?.selectedCompany,
  }));
  const usedSapCodes = useSelector(
    (state) => state.AddressReducer?.usedSapCodes || [],
  );

  const isMobile = useMediaQuery('(max-width: 1024px)');

  // Check for Google Maps API key
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  if (!googleMapsApiKey) {
    console.error('Google Maps API key is not configured');
  }

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapsApiKey || '',
    libraries: ['places'],
  });

  const zoom = 15;

  const [map, setMap] = useState(null);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [markerIcon, setMarkerIcon] = useState(null);

  const isGoogleMapsReady = isLoaded && !loadError;
  const onLoad = useCallback((map) => {
    setMap(map);
    // Create marker icon only when Google Maps is fully loaded
    if (window.google && window.google.maps) {
      const customIcon = {
        url:
          'data:image/svg+xml;charset=UTF-8,' +
          encodeURIComponent(`
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="50" fill="#995A0012" stroke="#995A00" stroke-width="1"/>
            <path d="M60 40c-5.52 0-10 4.48-10 10 0 7.5 10 20 10 20s10-12.5 10-20c0-5.52-4.48-10-10-10zm0 13.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" fill="#333333"/>
          </svg>
        `),
        scaledSize: new window.google.maps.Size(120, 120),
        anchor: new window.google.maps.Point(60, 75),
      };
      setMarkerIcon(customIcon);
    }
  }, []);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allPincodes, setAllPincodes] = useState([]);
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [isLoadingDistricts, setIsLoadingDistricts] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [addressTags, setAddressTags] = useState([]);
  const getStates = async () => {
    setIsLoadingStates(true);
    const { data, error, message } = await GetAllStates();
    setIsLoadingStates(false);
    if (!error) {
      const mappedStates = data.map((state) => ({
        label: state.state_name,
        value: state.id,
      }));
      setStates(mappedStates);
    } else {
      toast.error(message);
    }
  };
  const getDistricts = async (stateId) => {
    setDistricts([]);
    setIsLoadingDistricts(true);
    const { data, error, message } = await GetAllCityOfState(stateId);
    setIsLoadingDistricts(false);
    if (!error) {
      const mappedDistricts = data.map((district) => ({
        label: district.district_name,
        value: district.id,
      }));
      setDistricts(mappedDistricts);
    } else {
      console.error('Districts API error:', message);
    }
  };
  const getlocationPincode = async (
    districtId,
    locationId = null,
    PincodeId = null,
  ) => {
    const { data, error } = await getLocationAndPincodeAction(districtId, {
      location_id: locationId,
      pincode_id: PincodeId,
    });
    if (!error) {
      if (locationId && !formData.pincode) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
      } else if (PincodeId && !formData.city) {
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      } else if (!locationId && !PincodeId) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      }
    }
  };
  useEffect(() => {
    getStates();
  }, []);

  // Initialize marker icon when Google Maps is ready
  useEffect(() => {
    if (
      isGoogleMapsReady &&
      window.google &&
      window.google.maps &&
      !markerIcon
    ) {
      const customIcon = {
        url:
          'data:image/svg+xml;charset=UTF-8,' +
          encodeURIComponent(`
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="50" fill="#995A0012" stroke="#995A00" stroke-width="1"/>
            <path d="M60 40c-5.52 0-10 4.48-10 10 0 7.5 10 20 10 20s10-12.5 10-20c0-5.52-4.48-10-10-10zm0 13.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" fill="#333333"/>
          </svg>
        `),
        scaledSize: new window.google.maps.Size(120, 120),
        anchor: new window.google.maps.Point(60, 75),
      };
      setMarkerIcon(customIcon);
    }
  }, [isGoogleMapsReady, markerIcon]);

  const onUnmount = useCallback((map) => {
    if (
      typeof window !== 'undefined' &&
      window.google &&
      window.google.maps &&
      map
    ) {
      try {
        setMap(null);
        setMarkerIcon(null);
      } catch (error) {
        setMap(null);
        setMarkerIcon(null);
      }
    } else {
      setMap(null);
      setMarkerIcon(null);
    }
  }, []);

  const [formData, setFormData] = useState({
    addressLine1: '',
    addressLine2: '',
    district_id: '',
    district_name: '',
    location_id: '',
    location_name: '',
    pincode: '',
    state_id: '',
    state_name: '',
    address_type: '',
    address_type_other: '',
  });

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [districtID, setDistrictID] = useState(null);
  const [locationPermissionDenied, setLocationPermissionDenied] =
    useState(false);
  const [gpsAddressData, setGpsAddressData] = useState(null); // Track GPS fetched address

  const [mapCenter, setMapCenter] = useState({
    lat: coords?.lat || 28.7041, // Default to Delhi if no coordinates provided
    lng: coords?.lng || 77.1025,
  });

  useEffect(() => {
    if (coords && coords.lat && coords.lng) {
      setMapCenter({
        lat: Number(coords.lat),
        lng: Number(coords.lng),
      });
    } else {
      // Use default coordinates for display - these won't be sent in payload
      setMapCenter({
        lat: 28.7041, // Default to Delhi
        lng: 77.1025,
      });

      // If no coordinates provided, convert address to coordinates.
      const formattedAddress = formatCompleteAddress(addressDetails);
      if (formattedAddress) {
        getCoordinatesFromAddress(formattedAddress);
      }
    }

    // Clear GPS data when component mounts fresh
    if (!isAddressBeingEdited) {
      setGpsAddressData(null);
    }
  }, []);

  const getCurrentLocation = (isRetry = false) => {
    if (!navigator.geolocation) {
      if (!isRetry) {
        toast.error('Geolocation is not supported by this browser.');
      }
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 15000, // Increased timeout for better reliability
      maximumAge: 0, // Always request fresh location
    };

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const newCoordinates = {
          lat: latitude,
          lng: longitude,
        };

        // Update map center to show current location
        setMapCenter(newCoordinates);

        // Fetch address details for the current location
        try {
          const response = await reverseGeocodeAction(latitude, longitude);
          if (!response.error && response.data) {
            // Update form data with current location address
            const addressData = {
              ...response.data,
              landmark:
                response.data.landmark || response.data.formatted_address,
              geo_coordinates: {
                latitude: latitude,
                longitude: longitude,
              },
            };

            // Store GPS address data for display
            setGpsAddressData(addressData);

            setFormData({
              // In edit mode, never update address lines. In add mode, update with GPS data
              addressLine1: isAddressBeingEdited
                ? formData.addressLine1
                : addressData.address_line_1 || '',
              addressLine2: isAddressBeingEdited
                ? formData.addressLine2
                : addressData.address_line_2 || '',
              district_id: addressData.district_id || '',
              district_name:
                addressData.district_name || addressData.district || '',
              location_id: addressData.location_id || '',
              location_name: addressData.location_name || '',
              pincode:
                addressData.pincode_id?.toString() || addressData.pincode || '',
              state_id: addressData.state_id || '',
              state_name: toTitleCase(
                addressData.state_name || addressData.state || '',
              ),
              address_type: formData.address_type || '', // Preserve existing address type
              address_type_other: formData.address_type_other || '', // Preserve existing address type other
            });

            // Pre-populate dropdown options
            if (addressData.district_name || addressData.district) {
              setDistricts([
                {
                  value: addressData.district_name || addressData.district,
                  label: addressData.district_name || addressData.district,
                },
              ]);
            }
            if (addressData.state_name || addressData.state) {
              const stateName = toTitleCase(
                addressData.state_name || addressData.state,
              );
              setStates((prev) => {
                const stateExists = prev.some(
                  (option) => option.label === stateName,
                );
                if (!stateExists) {
                  return [...prev, { value: stateName, label: stateName }];
                }
                return prev;
              });
            }
            if (addressData.pincode_id || addressData.pincode) {
              const pincodeValue =
                addressData.pincode_id?.toString() || addressData.pincode;
              setAllPincodes([{ value: pincodeValue, label: pincodeValue }]);
            }

            // If we have IDs, trigger API calls to fetch all related data
            if (addressData.state_id) {
              getDistricts(addressData.state_id);
            }
            if (addressData.district_id) {
              getlocationPincode(addressData.district_id);
            }
            if (addressData.district_id && addressData.location_id) {
              getlocationPincode(
                addressData.district_id,
                addressData.location_id,
              );
            }
            if (addressData.district_id && addressData.pincode_id) {
              // If we have pincode_id, fetch cities for that pincode
              getlocationPincode(
                addressData.district_id,
                null,
                addressData.pincode_id,
              );
            }

            toast.success('Current location detected successfully!');
          } else {
            console.log('No address data returned from reverse geocoding');
          }
        } catch (error) {
          console.error('Error fetching address for current location:', error);
          toast.error('Failed to fetch address for current location.');
        }

        // Reset location permission denied state
        setLocationPermissionDenied(false);
      },
      (error) => {
        if (isRetry) {
          // For retry scenarios, only show browser settings tip for permission denied
          if (error.code === error.PERMISSION_DENIED) {
            setLocationPermissionDenied(true);
            toast.info(
              "Tip: Look for the location icon in your browser's address bar to manage location permissions.",
            );
          } else {
            setLocationPermissionDenied(false);
          }
        } else {
          // For initial request, show detailed error messages
          let errorMessage = 'Unable to retrieve your location. ';

          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage =
                'Location access was denied. Please enable location permission in your browser settings and try again.';
              setLocationPermissionDenied(true);
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage =
                'Location information is unavailable. Please check your GPS settings and try again.';
              break;
            case error.TIMEOUT:
              errorMessage =
                'Location request timed out. Please check your internet connection and try again.';
              break;
            default:
              errorMessage =
                'An unknown error occurred while getting your location. Please try again.';
              break;
          }

          toast.error(errorMessage);
        }
      },
      options,
    );
  };

  const handleCurrentLocationRequest = () => {
    getCurrentLocation(false);
  };

  const handleRetryLocation = () => {
    // Reset permission denied state
    setLocationPermissionDenied(false);

    // Request location permission again (with retry flag)
    getCurrentLocation(true);
  };

  const getCoordinatesFromAddress = async (address) => {
    if (!address || address.trim().length === 0) {
      return;
    }

    try {
      const response = await convertAddressToCoordinates(address);
      const { data, error } = response;
      if (error) {
        console.error('Error converting address to coordinates:', error);
        return null;
      }

      if (data && data.latitude && data.longitude) {
        const newCoordinates = {
          lat: Number(data.latitude),
          lng: Number(data.longitude),
        };
        setMapCenter(newCoordinates);
      }
    } catch (e) {
      console.error('Error:', e);
      return null;
    }
  };

  // Ref to track if we've already initialized the options from addressDetails
  const optionsInitializedRef = useRef(false);
  const isInitializingFromAddressDetails = useRef(false);

  // Check if addressDetails has meaningful data - include GPS data when available
  const displayAddressData = gpsAddressData || addressDetails;
  const hasAddressDetails =
    displayAddressData &&
    (displayAddressData?.address_line_1 ||
      displayAddressData?.formatted_address ||
      displayAddressData?.district ||
      displayAddressData?.district_name ||
      displayAddressData?.pincode ||
      displayAddressData?.pincode_id ||
      displayAddressData?.state ||
      displayAddressData?.state_name);

  // Initialize form data based on addressDetails
  useEffect(() => {
    if (hasAddressDetails) {
      isInitializingFromAddressDetails.current = true;

      // Find matching address tag from API data if available
      const findAddressTypeFromTagKey = (tagKey) => {
        if (!tagKey || !addressTags || addressTags.length === 0)
          return tagKey || '';

        // Look for exact match first
        const exactMatch = addressTags.find(
          (tag) => tag.id === tagKey || tag.id === tagKey.toUpperCase(),
        );
        if (exactMatch) return exactMatch.id;

        // Look for similar matches (e.g., REWARDS vs REWARD)
        const similarMatch = addressTags.find(
          (tag) => tag.id.includes(tagKey) || tagKey.includes(tag.id),
        );
        if (similarMatch) return similarMatch.id;

        // Default to original tagKey if no match found
        return tagKey;
      };

      // Only map address type if there's an actual address_tag_key
      const mappedAddressType = addressDetails?.address_tag_key
        ? findAddressTypeFromTagKey(addressDetails.address_tag_key)
        : '';
      const isCustomType =
        mappedAddressType === 'OTHER' &&
        addressDetails?.address_tag_key !== 'OTHER';

      setFormData({
        addressLine1: addressDetails?.address_line_1 || '',
        addressLine2: addressDetails?.address_line_2 || '',
        district_id: addressDetails?.district_id || '',
        district_name:
          addressDetails?.district_name || addressDetails?.district || '',
        location_id: addressDetails?.location_id || '',
        location_name:
          addressDetails?.location_name || addressDetails?.city || '',
        pincode: addressDetails?.pincode_id || addressDetails?.pincode || '',
        state_id: addressDetails?.state_id || '',
        state_name: addressDetails?.state_name || addressDetails?.state || '',
        address_type: mappedAddressType || addressDetails?.address_type || '',
        address_type_other:
          addressDetails?.address_type_other ||
          (isCustomType ? addressDetails?.address_tag_key : '') ||
          '', // Use address_tag_key as other type if it's custom and not already set in address_type_other
      });
      if (!isAddressBeingEdited) {
        if (addressDetails?.state_id) {
          getDistricts(addressDetails.state_id);
        }
        if (addressDetails?.district_id) {
          getlocationPincode(addressDetails.district_id);
        }
        if (addressDetails?.district_id && addressDetails?.location_id) {
          getlocationPincode(
            addressDetails.district_id,
            addressDetails.location_id,
          );
        }
        if (addressDetails?.district_id && addressDetails?.pincode_id) {
          getlocationPincode(
            addressDetails.district_id,
            null,
            addressDetails.pincode_id,
          );
        }
      }
    } else {
      // Reset to empty state when no address details
      isInitializingFromAddressDetails.current = false;
      optionsInitializedRef.current = false;
      setGpsAddressData(null); // Clear GPS data when resetting
      setFormData({
        addressLine1: '',
        addressLine2: '',
        district_id: '',
        district_name: '',
        location_id: '',
        location_name: '',
        pincode: '',
        state_id: '',
        state_name: '',
        address_type: '',
        address_type_other: '',
      });
    }
  }, [addressDetails, hasAddressDetails, non_reward, addressTags]);

  // Set address_type to 'REWARDS' when non_reward changes to false for existing addresses only
  useEffect(() => {
    if (
      !non_reward &&
      formData.address_type !== 'REWARDS' &&
      isAddressBeingEdited
    ) {
      setFormData((prev) => ({
        ...prev,
        address_type: 'REWARDS',
        address_type_other: '',
      }));
    }
  }, [non_reward, isAddressBeingEdited]);

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  // Load districts when state changes
  useEffect(() => {
    if (formData.state_id && !isInitializingFromAddressDetails.current) {
      // Use the state value directly as it should be the state ID
      getDistricts(formData.state_id);
    }
  }, [formData.state_id]);

  // Load pincodes when district changes
  useEffect(() => {
    if (districtID && !isInitializingFromAddressDetails.current) {
      setFormData((prev) => ({
        ...prev,
        district_id: districtID,
      }));
    }
  }, [districtID]);

  // Pre-populate options if addressDetails exist
  useEffect(() => {
    if (hasAddressDetails && !optionsInitializedRef.current) {
      // Mark as initialized to prevent re-running
      optionsInitializedRef.current = true;

      const stateName = toTitleCase(
        addressDetails?.state_name || addressDetails?.state,
      );
      const stateId = addressDetails?.state_id;

      // For editing mode, load full dropdown options
      if (isAddressBeingEdited && (stateName || stateId)) {
        if (stateId) {
          // If we have state ID, use it directly to load districts
          getDistricts(stateId);
        } else {
          // Find the state in the states list and trigger district loading
          const matchingState = states.find(
            (state) => state.label === stateName || state.value === stateName,
          );

          if (matchingState) {
            // Update form data with correct state value for API calls
            setFormData((prev) => ({
              ...prev,
              state_id: matchingState.value,
              state_name: matchingState.label,
            }));
            getDistricts(matchingState.value);
          }
        }
      } else {
        // For non-editing mode, just set the current values as options
        const districtName =
          addressDetails?.district_name || addressDetails?.district;
        if (districtName) {
          setDistricts([{ value: districtName, label: districtName }]);
        }

        const pincodeValue =
          addressDetails?.pincode_id?.toString() || addressDetails?.pincode;
        if (pincodeValue) {
          setAllPincodes([{ value: pincodeValue, label: pincodeValue }]);
        }
      }

      // Reset the initialization flag after setting options
      setTimeout(() => {
        isInitializingFromAddressDetails.current = false;
      }, 0);
    }

    // Reset the flag when addressDetails changes (e.g., when switching between different addresses)
    if (!hasAddressDetails && optionsInitializedRef.current) {
      optionsInitializedRef.current = false;
      isInitializingFromAddressDetails.current = false;
    }
  }, [hasAddressDetails, states, isAddressBeingEdited]);

  // Load cities when districts are loaded during editing mode
  useEffect(() => {
    if (isAddressBeingEdited && districts.length > 0 && hasAddressDetails) {
      const districtName =
        addressDetails?.district_name || addressDetails?.district;
      const districtId = addressDetails?.district_id;

      if (districtName || districtId) {
        let targetDistrictId = districtId;

        if (!districtId) {
          // Find the matching district by name
          const matchingDistrict = districts.find(
            (district) =>
              district.label === districtName ||
              district.value === districtName,
          );
          targetDistrictId = matchingDistrict?.value;
        }

        if (targetDistrictId) {
          // Update form data with correct district value for API calls
          const matchingDistrict = districts.find(
            (district) => district.value === targetDistrictId,
          );
          if (matchingDistrict) {
            setFormData((prev) => ({
              ...prev,
              district_id: matchingDistrict.value,
              district_name: matchingDistrict.label,
            }));
          }
          // Load cities and pincodes for this district
          getlocationPincode(targetDistrictId);
        }
      }
    }
  }, [districts, isAddressBeingEdited, hasAddressDetails, addressDetails]);

  // Set the city value when cities are loaded during editing mode
  useEffect(() => {
    if (isAddressBeingEdited && allCities.length > 0 && hasAddressDetails) {
      const locationName = addressDetails?.location_name;
      const locationId = addressDetails?.location_id;

      if ((locationName || locationId) && !formData.location_id) {
        let targetCity = null;

        if (locationId) {
          // Find city by ID
          targetCity = allCities.find((city) => city.value == locationId);
        } else {
          // Find city by name
          targetCity = allCities.find((city) => city.label === locationName);
        }

        if (targetCity) {
          setFormData((prev) => ({
            ...prev,
            location_id: targetCity.value,
            location_name: targetCity.label,
          }));

          // If we have district, load pincodes for this city
          if (formData.district_id || addressDetails?.district_id) {
            const districtId =
              formData.district_id || addressDetails?.district_id;
            getlocationPincode(districtId, targetCity.value);
          }
        }
      }
    }
  }, [
    allCities,
    isAddressBeingEdited,
    hasAddressDetails,
    addressDetails,
    formData.location_id,
    formData.district_id,
  ]);

  // Set the pincode value when pincodes are loaded during editing mode
  useEffect(() => {
    if (isAddressBeingEdited && allPincodes.length > 0 && hasAddressDetails) {
      const pincodeValue =
        addressDetails?.pincode_id || addressDetails?.pincode;

      if (pincodeValue && !formData.pincode) {
        // Find the matching pincode by ID or value
        const matchingPincode = allPincodes.find(
          (pincode) =>
            pincode.value == pincodeValue || pincode.label === pincodeValue,
        );

        if (matchingPincode) {
          setFormData((prev) => ({
            ...prev,
            pincode: matchingPincode.value,
          }));
        }
      }
    }
  }, [
    allPincodes,
    isAddressBeingEdited,
    hasAddressDetails,
    addressDetails,
    formData.pincode,
  ]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear validation errors
    if (validationErrors[field]) {
      setValidationErrors((prev) => ({ ...prev, [field]: '' }));
    }

    // Handle cascading dropdown logic
    if (field === 'state_id') {
      setFormData((prev) => ({
        ...prev,
        district_id: '',
        district_name: '',
        location_id: '',
        location_name: '',
        pincode: '',
      }));
      setDistricts([]);
      setAllCities([]);
      setAllPincodes([]);
      if (value) {
        const selectedState = states.find((state) => state.value === value);
        setFormData((prev) => ({
          ...prev,
          state_name: selectedState?.label || '',
        }));
        getDistricts(value);
      }
    } else if (field === 'district_id') {
      setFormData((prev) => ({
        ...prev,
        location_id: '',
        location_name: '',
        pincode: '',
      }));
      setAllCities([]);
      setAllPincodes([]);
      if (value) {
        const selectedDistrict = districts.find(
          (district) => district.value === value,
        );
        setFormData((prev) => ({
          ...prev,
          district_name: selectedDistrict?.label || '',
        }));
        getlocationPincode(value);
      }
    } else if (field === 'location_id') {
      setFormData((prev) => ({ ...prev, pincode: '' }));
      if (value) {
        const selectedCity = allCities.find((city) => city.value === value);
        setFormData((prev) => ({
          ...prev,
          location_name: selectedCity?.label || '',
        }));
        getlocationPincode(formData.district_id, value);
      }
    } else if (field === 'pincode') {
      if (value) {
        getlocationPincode(formData.district_id, null, value);
      }
    }
  };

  const handleAddressTypeChange = (addressType) => {
    setFormData((prev) => ({
      ...prev,
      address_type: addressType,
      address_type_other:
        addressType === 'OTHER' ? prev.address_type_other : '',
    }));

    if (validationErrors.address_type) {
      setValidationErrors((prev) => ({
        ...prev,
        address_type: '',
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.addressLine1.trim()) {
      newErrors.addressLine1 = 'Address Line 1 is required';
    }

    if (
      (!hasAddressDetails || isAddressBeingEdited) &&
      !districtID &&
      !formData.district_id
    ) {
      newErrors.district_id = 'District is required';
    }

    if ((!hasAddressDetails || isAddressBeingEdited) && !formData.pincode) {
      newErrors.pincode = 'Pincode is required';
    } else if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = 'Pincode must be 6 digits';
    }

    if ((!hasAddressDetails || isAddressBeingEdited) && !formData.state_id) {
      newErrors.state_id = 'State is required';
    }

    // Only validate address type for non-reward scenarios
    if (non_reward) {
      if (!formData.address_type) {
        newErrors.address_type = 'Address type is required';
      }

      if (
        formData.address_type === 'OTHER' &&
        !formData.address_type_other.trim()
      ) {
        newErrors.address_type_other = 'Please specify the address type';
      }
    }

    setValidationErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveAddress = () => {
    if (validateForm()) {
      setIsConfirmationModalOpen(true);
    }
  };

  const handleConfirmAddress = (confirmedData) => {
    setIsConfirmationModalOpen(false);
    onSaveAddress(confirmedData);
    onAddressAdded();
  };

  const handleCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  const onMapClick = (event) => {
    setShowInfoWindow(false);
  };

  const handleMarkerClick = () => {
    setShowInfoWindow(true);
  };
  const handleChangeAddressClick = () =>{
    setIsConfirmationModalOpen(false);
    onBack();
  }

  const isSaveButtonDisabled = () => {
    const requiresAddressType =
      non_reward &&
      addressDetails?.address_tag_key !== 'REWARD' &&
      addressDetails?.address_tag_key !== 'REWARDS' &&
      formData.address_type !== 'REWARDS';

    if (requiresAddressType) {
      if (!formData.address_type) {
        return true;
      }

      if (
        formData.address_type === 'OTHER' &&
        !formData.address_type_other.trim()
      ) {
        return true;
      }
    }

    if (hasAddressDetails && !isAddressBeingEdited) {
      // When address details exist but not editing, only check if address line 1 is filled
      return !formData.addressLine1.trim();
    } else {
      // When no address details OR when editing, check all required fields
      return (
        !formData.addressLine1.trim() ||
        !formData.state_id ||
        (!districtID && !formData.district_id) ||
        !formData.pincode
      );
    }
  };
  const getAddressTag = async () => {
    const { error, message, data } = await getAddressTagsAction();
    if (!error) {
      setAddressTags(data);
    } else {
      toast.error(message);
    }
  };
  useEffect(() => {
    getAddressTag();
  }, []);
  const {
    selectedEntity: selectedCompanyEntity,
    selectedEntityInfo,
  } = useSelector(
    (state) => state.entityReducer
  );

  const selectedAddressTypeLabel =
    formData.address_type === 'OTHER'
      ? formData.address_type_other
      : addressTags.find((item) => item.id === formData.address_type)?.label ||
        formData.address_type ||
        addressDetails?.address_type_other ||
        addressDetails?.address_tag_key ||
        '';

  const isRewards = addressDetails?.address_tag_key === 'REWARDS';
  return (
    <Box
      sx={{
        height: isMobile ? '100vh' : '589px',
        width: isMobile ? '100%' : '618px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: isMobile ? 0 : '12px',
      }}
    >
      {/* Close/Back Button */}
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          zIndex: 1002,
        }}
      >
        <IconButton
          onClick={onBack}
          sx={{
            backgroundColor: 'white',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 24, color: '#333' }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          flex: 1,
          position: 'relative',
          // minHeight: '200px',
        }}
      >
        {isGoogleMapsReady && window.google && window.google.maps ? (
          <GoogleMap
            key='google-map-instance'
            mapContainerStyle={{
              height: '100%',
              width: '100%',
              // position: 'relative',
              // zIndex: 1,
            }}
            center={mapCenter}
            zoom={zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            onClick={onMapClick}
            options={{
              styles: mapStyles,
              disableDefaultUI: true,
              zoomControl: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              gestureHandling: 'none',
            }}
          >
            <Marker
              position={mapCenter}
              draggable={false}
              icon={markerIcon}
              onClick={handleMarkerClick}
            />

            {showInfoWindow && (
              <InfoWindow
                position={mapCenter}
                onCloseClick={() => setShowInfoWindow(false)}
              >
                <Box sx={{ textAlign: 'center', minWidth: '120px' }}>
                  <Typography
                    variant='subtitle2'
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    📍 Selected Location
                  </Typography>
                  <Typography
                    variant='caption'
                    sx={{ display: 'block', color: '#666' }}
                  >
                    Lat: {(mapCenter?.lat || 0).toFixed(6)}
                  </Typography>
                  <Typography
                    variant='caption'
                    sx={{ display: 'block', color: '#666' }}
                  >
                    Lng: {(mapCenter?.lng || 0).toFixed(6)}
                  </Typography>
                </Box>
              </InfoWindow>
            )}
          </GoogleMap>
        ) : loadError ? (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f5f5f5',
              flexDirection: 'column',
            }}
          >
            <Typography
              variant='body1'
              color='error'
            >
              Error loading Google Maps
            </Typography>
            <Typography
              variant='body2'
              color='text.secondary'
            >
              {!googleMapsApiKey
                ? 'Google Maps API key is missing. Please check your environment configuration.'
                : 'Please check your API key and internet connection'}
            </Typography>
            {googleMapsApiKey && (
              <Typography
                variant='body2'
                color='text.secondary'
              >
                Error: {loadError?.message || 'Unknown error'}
              </Typography>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f5f5f5',
            }}
          >
            <Typography
              variant='body1'
              color='text.secondary'
            >
              {!isLoaded ? 'Loading Google Maps...' : 'Initializing Map...'}
            </Typography>
          </Box>
        )}
        {!is_PWA && (
          <Box
            sx={{
              position: 'absolute',
              bottom: '20px',
              left: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'center',
              zIndex: 1001,
            }}
          >
            <CustomButton
              variant='text'
              color='primary'
              label={
                locationPermissionDenied
                  ? 'Use Current Location'
                  : 'Use Current Location'
              }
              onClick={() => {
                if (locationPermissionDenied) {
                  handleRetryLocation();
                } else {
                  handleCurrentLocationRequest();
                }
              }}
              sx={{
                height: '40px',
                width: '230px',
                backgroundColor: 'white',
                marginBottom: '8px',
              }}
              leftIcon={GpsFixedIcon}
            />
          </Box>
        )}
      </Box>

      <Box
        sx={{
          backgroundColor: 'white',
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          height: isMobile
            ? isRewards
              ? '200px'
              : '670px'
            : isRewards
              ? '300px'
              : '300px',
          overflowY: 'auto',
          marginTop: '-20px',
          position: 'relative',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Typography variant='labelD'>Firm Name</Typography>
          <Typography variant='body1'>
            {selectedCompany?.company_name}
          </Typography>
        </Box>
        {(!non_reward || isAddressBeingEdited) &&
          (addressDetails?.external_system_code || selectedSapCode) && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <TextField
              id="select-sap-code"
              label={'SAP Code*'}
              value={addressDetails?.external_system_code || selectedSapCode}
              fullWidth
              fetchedState={true}
            />
          </Box>
        )}
        {hasAddressDetails && (
          <Box>
            {displayAddressData?.landmark && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
              >
                <PlaceOutlinedIcon
                  sx={{
                    height: isMobile ? '16px' : '24px',
                    width: isMobile ? '16px' : '24px',
                    marginRight: '2px',
                  }}
                  color='#666666'
                />
                <Typography variant='bodyL'>
                  {displayAddressData?.landmark || 'Selected Location'}
                </Typography>
              </Box>
            )}
            <Typography
              variant='body1'
              sx={{ marginTop: '4px' }}
            >
              {displayAddressData?.formatted_address ||
                formatCompleteAddress(displayAddressData)}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            py: 1,
            pb: 3,
          }}
        >
          <Grid
            container
            spacing={{ xs: 1, md: 2 }}
          >
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextField
                label='Address line 1*'
                fullWidth
                value={formData.addressLine1}
                onChange={(e) =>
                  handleInputChange('addressLine1', e.target.value)
                }
                placeholder={'Enter Address line 1'}
                size='small'
                error={!!validationErrors.addressLine1}
                helperText={validationErrors.addressLine1}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextField
                label='Address line 2'
                fullWidth
                value={formData.addressLine2}
                onChange={(e) =>
                  handleInputChange('addressLine2', e.target.value)
                }
                size='small'
                placeholder={'Enter Address line 2'}
                error={!!validationErrors.addressLine2}
                helperText={validationErrors.addressLine2}
              />
            </Grid>
          </Grid>
          {(!hasAddressDetails || isAddressBeingEdited) &&
            !gpsAddressData &&
            !(addressDetails?.geo_coordinates && addressDetails?.landmark) && (
              <Grid
                container
                spacing={{ xs: 1, md: 2 }}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <CustomSelect
                    label='State*'
                    fullWidth
                    value={formData.state_id}
                    onChange={(e) =>
                      handleInputChange('state_id', e.target.value)
                    }
                    placeholder={'Select State'}
                    error={!!validationErrors.state_id}
                    helperText={validationErrors.state_id}
                    displayEmpty
                    disabled={isLoadingStates}
                  >
                    {states.map((state) => (
                      <MenuItem
                        key={state.value}
                        value={state.value}
                      >
                        {state.label}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <CustomSelect
                    label='District*'
                    fullWidth
                    value={formData.district_id}
                    onChange={(e) =>
                      handleInputChange('district_id', e.target.value)
                    }
                    placeholder={'Select District'}
                    error={!!validationErrors.district_id}
                    helperText={validationErrors.district_id}
                    displayEmpty
                    disabled={!formData.state_id}
                  >
                    {districts.map((district) => (
                      <MenuItem
                        key={district.value}
                        value={district.value}
                      >
                        {district.label}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <CustomSelect
                    label='City*'
                    fullWidth
                    value={formData.location_id}
                    onChange={(e) =>
                      handleInputChange('location_id', e.target.value)
                    }
                    error={!!validationErrors.location_id}
                    helperText={validationErrors.location_id}
                    displayEmpty
                    disabled={!formData.district_id}
                    placeholder={'Select City'}
                  >
                    {allCities.map((city) => (
                      <MenuItem
                        key={city.value}
                        value={city.value}
                      >
                        {city.label}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <CustomSelect
                    label='Pincode*'
                    fullWidth
                    value={formData.pincode}
                    onChange={(e) =>
                      handleInputChange('pincode', e.target.value)
                    }
                    error={!!validationErrors.pincode}
                    helperText={validationErrors.pincode}
                    displayEmpty
                    disabled={!formData.district_id}
                    placeholder={'Select Pincode'}
                  >
                    <MenuItem value=''>Select Pincode</MenuItem>
                    {allPincodes.map((pincode) => (
                      <MenuItem
                        key={pincode.value}
                        value={pincode.value}
                      >
                        {pincode.label}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </Grid>
              </Grid>
            )}
          {non_reward &&
            !(
              addressDetails?.address_tag_key === 'REWARD' ||
              addressDetails?.address_tag_key === 'REWARDS' ||
              formData.address_type === 'REWARDS'
            ) && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='labelS'>Save as</Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: { xs: 1, md: 1 },
                  }}
                >
                  {addressTags && addressTags.length > 0 ? (
                    addressTags
                      .filter(
                        (item) => item.id !== 'REWARDS' && item.id !== 'REWARD',
                      ) // Exclude REWARDS from chip display
                      .map((item) => (
                        <StandardChip
                          key={item.id}
                          size={isMobile ? 'small' : 'medium'}
                          label={item.label}
                          selected={formData.address_type === item.id}
                          onChange={() => handleAddressTypeChange(item.id)}
                        />
                      ))
                  ) : (
                    <Typography
                      variant='body2'
                      color='text.secondary'
                    >
                      Loading address types...
                    </Typography>
                  )}
                </Box>
                {formData.address_type === 'OTHER' && (
                  <TextField
                    label='Save as'
                    fullWidth
                    variant='standard'
                    value={formData.address_type_other}
                    onChange={(e) =>
                      handleInputChange('address_type_other', e.target.value)
                    }
                    placeholder='example: Badi Dukaan'
                    error={!!validationErrors.address_type_other}
                    helperText={validationErrors.address_type_other}
                  />
                )}
              </Box>
            )}
        </Box>
        <CustomButton
          variant='filled'
          color='warning'
          label='Save Address'
          fullWidth
          disabled={isSaveButtonDisabled()}
          onClick={handleSaveAddress}
        />
      </Box>
      <ReusableModal
        open={isConfirmationModalOpen}
        onClose={handleCloseConfirmationModal}
        centerAlign={!isMobile}
        maxHeight={isMobile ? '100vh' : '589px'}
        topDesktop={'10%'}
        topMobile={'0%'}
        showHeader={false}
        scrollable={false}
        pt={0}
        px={0}
        pb={0}
        maxWidth={isMobile ? '100%' : '618px'}
        hideBackdrop={true}
        modalSx={{
          zIndex: 1400, // Higher than AddressFormModal
        }}
      >
        <AddressConfirmationModal
          addressData={{
            id: addressDetails?.address_id || null,
            address_line_1:
              formData.addressLine1 || addressDetails?.address_line_1 || '',
            address_line_2:
              formData.addressLine2 || addressDetails?.address_line_2 || '',
            state_id: formData.state_id || addressDetails?.state_id || '',
            state_name:
              formData.state_name ||
              addressDetails?.state_name ||
              addressDetails?.state ||
              '',
            district_id:
              formData.district_id || addressDetails?.district_id || '',
            district_name:
              formData.district_name ||
              addressDetails?.district_name ||
              addressDetails?.district ||
              '',
            location_id:
              formData.location_id || addressDetails?.location_id || '',
            location_name:
              formData.location_name || addressDetails?.location_name || '',
            pincode_id:
              formData.pincode ||
              addressDetails?.pincode_id ||
              addressDetails?.pincode ||
              '',
            phone_no: addressDetails?.whatsapp_no || '',
            landmark:
              gpsAddressData?.landmark || addressDetails?.landmark || '',
            geo_coordinates:
              gpsAddressData?.geo_coordinates ||
              (coords && coords.lat && coords.lng
                ? {
                    latitude: Number(coords.lat),
                    longitude: Number(coords.lng),
                  }
                : null), // Include GPS coordinates or coords from LocationMapSelector
            address_type:
              formData.address_type || addressDetails?.address_type || '',
            address_type_other:
              formData.address_type_other ||
              addressDetails?.address_type_other ||
              '',
            address_type_label: selectedAddressTypeLabel,
            locationTitle:
              addressDetails?.formatted_address ||
              addressDetails?.landmark ||
              'Selected Location',
            company_esi_id:
              (addressDetails?.company_esi_id && isAddressBeingEdited)
                ? addressDetails?.company_esi_id
                : selectedCompanyEsiId || selectedEntityInfo?.esi_id || null,
            external_system_code:
              (addressDetails?.external_system_code && isAddressBeingEdited)
                ? addressDetails?.external_system_code
                : selectedSapCode ||
                  selectedEntityInfo?.external_system_code ||
                  null,
          }}
          coordinates={
            gpsAddressData?.geo_coordinates
              ? {
                  lat: gpsAddressData.geo_coordinates.latitude,
                  lng: gpsAddressData.geo_coordinates.longitude,
                }
              : coords && coords.lat && coords.lng
                ? coords
                : null
          } // Pass GPS coordinates or coords from LocationMapSelector
          onConfirm={handleConfirmAddress}
          onBack={handleChangeAddressClick}
          isAddressBeingEdited={isAddressBeingEdited}
          non_reward={non_reward}
        />
      </ReusableModal>
    </Box>
  );
};

export default AddressFormModal;
